import { forwardRef } from "react";

import { cn } from "@/utils";

interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
	selected?: boolean;
	isLast?: boolean;
}

export const TableRow = forwardRef<HTMLTableRowElement, TableRowProps>(
	function TableRow(
		{
			children,
			onClick,
			className,
			selected = false,
			isLast = false,
			...props
		},
		ref,
	) {
		return (
			<tr
				ref={ref}
				onClick={onClick}
				onKeyDown={(e) => {
					if ((e.key === "Enter" || e.key === " ") && onClick) {
						e.preventDefault();
						onClick(e as unknown as React.MouseEvent<HTMLTableRowElement>);
					}
				}}
				className={cn(
					!isLast && "border-b border-border-secondary",
					"hover:bg-bg-secondary",
					selected && "bg-bg-tertiary border-l-4 border-border-focus",
					onClick && "cursor-pointer",
					className,
				)}
				{...props}
			>
				{children}
			</tr>
		);
	},
);
